var $2e2ff110430f7001$exports = {};
$2e2ff110430f7001$exports = {
    "colorFormat": `\u{C0C9}\u{C0C1} \u{D615}\u{C2DD}`,
    "hex": `HEX`,
    "hsb": `HSB`,
    "hsl": `HSL`,
    "rgb": `RGB`
};


export {$2e2ff110430f7001$exports as default};
//# sourceMappingURL=ko-KR.mjs.map
